<template>
    <b-card-text>
        <slot />
    </b-card-text>
</template>

<script>
// Components.
import {BCardText} from 'bootstrap-vue'

export default {
    components: {BCardText},
}
</script>